"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toHexColor = toHexColor;
exports.reverseCLR = reverseCLR;
exports.DisplayColorType = void 0;

/**
 * This function converts a decimal RGB value to hex
 * @param decRGB
 * @returns {number}
 */
function toHexColor(decRGB) {
  var red = decRGB >> 16 & 0xFF;
  var green = decRGB >> 8 & 0xFF;
  var blue = decRGB & 0xFF;
  red = red.toString(16);
  green = green.toString(16);
  blue = blue.toString(16);
  if (red.length < 2) red = '0' + red;
  if (green.length < 2) green = '0' + green;
  if (blue.length < 2) blue = '0' + blue;
  return red + green + blue;
}
/**
 * This function returns a decimal BGR ordered color from a decimal RGB ordered color or visa versa!
 * @param decRGB
 * @returns {number}
 */


function reverseCLR(decRGB) {
  var blue = decRGB & 0xFF;
  var green = decRGB >> 8 & 0xFF;
  var red = decRGB >> 16 & 0xFF;
  return (blue << 16) + (green << 8) + red;
}
/**
 * Some annotations (such as Macro results) may contain a display color as a decimal RGB; convert to hex color string for the web client
 * @param val
 * @constructor
 */


var DisplayColorType = function DisplayColorType(val) {
  return "#".concat(toHexColor(reverseCLR(val)));
};

exports.DisplayColorType = DisplayColorType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/types/DisplayColorType.js
// module id = 78
// module chunks = 0